import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(null)); }, [slug]);
  if (!post) return <div className="max-w-[800px] mx-auto px-5 py-20 text-gray-400">Loading…</div>;

  return (
    <article className="max-w-[820px] mx-auto px-5 py-16" data-testid={`blog-post-${slug}`}>
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-white mb-8"><ArrowLeft className="w-4 h-4" /> Back to journal</Link>
      <p className="label-mono mb-3">{post.category}</p>
      <h1 className="font-display text-4xl md:text-6xl font-light tracking-tighter mb-6">{post.title}</h1>
      <div className="text-sm text-gray-500 mb-8">{post.author} · {new Date(post.published_at).toLocaleDateString()}</div>
      <img src={post.image_url} alt="" className="w-full rounded-2xl aspect-[16/9] object-cover mb-10" />
      <div className="prose prose-invert max-w-none text-gray-200 leading-relaxed text-lg space-y-5">
        {post.content.split(/\n+/).map((para, i) => <p key={i}>{para}</p>)}
      </div>
    </article>
  );
}
